var tripitems="";     
var bTripContentsDirty=false;
var bEditDirty=false;
function getTripPlaceName() {
    var s= $(".workspace").data("pname")
    if (s==undefined){ s="";}
    return  s
}

function getTripPlaceId() {
    var s= $(".workspace").data("pid")
    if (s==undefined){ s="";}
    return s;
}

function getTripPlaceType() {
    var s= $(".workspace").data("pitype")
    if (s==undefined){ s="";}
    return s;                                                         
}   

function isPlaceInTrip() {
     return $(".btn-trip-place-remove").is(':visible')
     }

function getCruiseDetails() {
    var cru=$(".cruise-details")
    if ($(cru).length=0){ cru= $(".workspace") }
    return cru;
}

function getCruiseSailDate() {
    var s= $(getCruiseDetails()).data("cruise-date")    
    if(s==undefined){s="";}
    return s;
}

function getCruiseSailId() { 
    var s= $(getCruiseDetails()).data("cruise-id")    
    if(s==undefined){s="";}
    return s;
}
   
function setTripDetailDirty(){
    if ($('.btn-trip-place-add').length>0){
        if ($('.btn-trip-place-add').is(':visible')) {
            $(".btn-trip-place-add").addClass("pulse-primary")
            bTripContentsDirty=true;
        }
    }
}    

function setTripDetailClean(){
    $(".btn-trip-place-add").removeClass("pulse-primary")
    bTripContentsDirty=false;    
}


function setEditDirty(){
    //console.log('make trip dirty')
    $(".btn-detail-save").addClass("pulse-primary")
    bEditDirty=true;       
}    

function setEditClean(){  
    //console.log('make trip clean')   
    $(".btn-detail-save").removeClass("pulse-primary")
    bEditDirty=false;    
}


$(function () {

      $('#form-traveler-detail,#form-profile-detail').on('input change', function () {setEditDirty();}); 



    initAddToCheckStatePort();    

   $(".btn-select-trip").on('click',function (e){
        e.preventDefault();  
        showModal({ url: "/widgets/Trip/Trip-Select.aspx?m=2", saveText: "or Create New Trip", title: "Select a Trip", callback: function (modal) { tripSelectOpenCreateTrip(modal);} });
     });
    
    $("#drpDates").on('change',function (e){
        Page_Blur(true);
        var sParm="id";
        var sId=     $(this).val();
        var dt=$(this).find('option:selected').text();
        if (sId==dt){    
            sParm="dt";
        }
        $(getCruiseDetails()).data("cruise-id", sId)  //set new values
         $(getCruiseDetails()).data("cruise-date", dt) 
        if (getTripDetailRID()!="" && isPlaceInTrip() ){   
            //save the new  id                                          
            UpdateReportItem(getTripDetailRID(), getTripPlaceId(),  collectItems(),collectPOIItems(),   getTripDetailName(), getTripPlaceName(),getTripPlaceType(),tripCruiseDateUpdated_callback)  
          }   else{
              //refresh the page
             refreshWithQueryParam(sParm,getCruiseSailId()) ;
          }
                
      
    });

    $("#selShipDeck").on('change',function (e){
       $(".deck-plan").hide();
       $("#" + $(this).val()).show();
    });

    $(".btn-trip-place-remove").on('click',function (e){
        e.preventDefault();  
          //if we don't have a trip, we shouldn't be doing anything (this button should not show at all)
         var rid=getTripDetailRID();
         if (rid!=""){         
             if (confirm("Are you sure you want to remove " + getTripPlaceName() + " from the trip '" + getTripDetailName() + "'?")){
                  RemoveReportItem(rid, getTripPlaceId(), getTripDetailName(), getTripPlaceName(),getTripPlaceType(),tripPlaceRemoved_callback)
            }       
         }         
     });

    $(".btn-trip-place-add").on('click',function (e){
         e.preventDefault();
         //if we don't have a trip, open then select trip dialog 
         var rid=getTripDetailRID();
         if (rid==""){   
             showModal({ url: "/widgets/Trip/Trip-Select.aspx?m=1", saveText: "or Create New Trip", title: "Add Item(s) to Trip Plan", callback: function (modal) { tripSelectOpenCreateTrip(modal);} });
          }
          else {
            //add place to trip with any selected options
            Page_Blur(true);
            UpdateReportItem(rid, getTripPlaceId(),  collectItems(), collectPOIItems(),  getTripDetailName(), getTripPlaceName(),getTripPlaceType(),tripPlaceAdded_callback,null)
          }
     });
              
     $(".btn-trip-place-send").on('click',function (e){
        e.preventDefault();  
        //save the current selections to as a quick report trip and open send
        var pois=collectPOIItems();
        var items=collectItems();
        if (pois=="" && items==""){
            alert ('Please select one or more place options to send.')
            return;
        }
        CreateQuickReport(getTripPlaceId(),  items, pois,  getTripPlaceName(),getTripPlaceType(),tripQuickSend_callback,null)      
     });

     $(".btn-trip-place-print").on('click',function (e){
        e.preventDefault();  
        //save the current selections to as a quick report trip and open print
        var pois=collectPOIItems();
        var items=collectItems();
        if (pois=="" && items==""){
            alert ('Please select one or more place options to print.')
            return;
        }
        CreateQuickReport(getTripPlaceId(),  items, pois,  getTripPlaceName(),getTripPlaceType(),tripQuickPrint_callback,null)      
  
     });    

      // Check the number of child elements in the carousel
      var $carousel = $('.item-slider');
      if ($carousel.length>0) {
          var imageCount = $carousel.children().length;

          // Initialize Slick Carousel only if there are more than one image
          if (imageCount > 2) {

             $carousel.slick({
                dots: true,
                slidesToScroll:2 ,
                infinite: false ,
                speed: 750,       
                autoplay: false,
                autoplaySpeed: 2000,
                pauseOnDotsHover:true,
                arrows:true,   
                variableWidth: true
             });

          } else {
               $carousel.slick({
                dots: false,
                slidesToScroll:2 ,
                infinite:false  ,
                speed: 750,       
                autoplay: false,      
                pauseOnDotsHover:true,
                arrows:false,   
                variableWidth: true
             });

          }
    }

    $('.center').slick({
                    dots: true,
            slidesToShow: 6, 
            slidesToScroll: 6 ,
            infinite: true  ,
            speed: 750,       
            autoplay: false,
            autoplaySpeed: 2000,
            pauseOnDotsHover:true,
            arrows:true,

  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

}) 

function updateSearchChecks(){
    $(".chk-search-item-port,.chk-search-item").map(function (i, obj) {
        var key=$(this).val();
        $(this).prop('checked',searchreportitems.indexOf('|'+key+'|')>-1);
    });  
}

function initAddToCheckStatePort(){
    //set checkboxes bases on report state
    $(".chk-search-item-port").on('click',function (e){
        return quickaddcheck($(this));
    });                              
    updateSearchChecks();   
}

function quickaddcheck(e){      
    var rid=getTripDetailRID();
    var id= $(e).val();
    var n=   $(e).data("placename"); 
    var typ=   $(e).data("subtype");
    var bRemove=!$(e).prop('checked');
                 
    var sid = getCruiseSailId();
    var sdt = getCruiseSailDate(); 

    if (bRemove){                                
        if (rid!=""){
            if (confirm("Are you sure you want to remove " + n + " from the trip '" + getTripDetailName() + "'?")){RemoveReportItem(rid, id, getTripDetailName(), n,typ,tripQuickAddRemoved_callback)}
            else{return false;}
        }                
    } else
    {                
        //if we don't have a trip, open then select trip dialog 
        if (rid==""){  
            showModal({ url: "/widgets/Trip/Trip-Select.aspx?m=3&id=" + id + "&typ=" + typ + "&n=" + escape(n) + "&sid=" + escape(sid) +"&sdt=" + escape(sdt), saveText: "or Create New Trip", title: "Add Item to Trip Plan", callback: function (modal) { tripSelectOpenCreateTrip(modal); } });
        }
        else {                                    
            //add place to trip with default options
            Page_Blur(true);
            QuickAddReportItem(rid, id, typ,  getTripDetailName(), n,tripQuickAddItem_callback, sid, sdt);
        }
    }
    return true;
}

function tripPlaceRemoved_callback(rid, riid,  rname, riname,err) {
    if (err){ 
        showSupportNotification("Unable to remove " + riname + " from the trip '" + rname+  "'");   
    }else{      
        setTripDetailClean()
        showSystemNotification(riname + " has been removed from the trip '"  + rname+  "'");  
        $(".btn-trip-place-add,.btn-trip-place-add-drop").show();
        $(".btn-trip-place-remove").hide();                 
    }
}

function tripSelectedPlaceAdded_callback(rid, riid,  options,  rname, riname,err) {
    if (err){ 
        showSupportNotification("Unable to add " + riname + " to the trip '" + rname+  "'");   
    }else{                                             
        showSystemNotification(riname + " has been added to the trip '"  + rname+  "'.  Refreshing your page.");  
        refreshPageForTrip(rid,rname)
    }
}
                   
function tripPlaceUpdated_callback(rid, riid,  options,  rname, riname,err,msg) {
    if (err){           
        showSupportNotification("Unable to update " + riname + " in the trip '" + rname+  "'");   
    }else{
        setTripDetailClean()
        var m=(msg==null?riname + " has been updated in the trip '"  + rname+  "'":msg)
        showSystemNotification(m);       
    }
}

function tripCruiseDateUpdated_callback(rid, riid,  options,  rname, riname,err) {
    if (err){           
        showSupportNotification("Unable to update " + riname + " in the trip '" + rname+  "'");   
    }else{
        setTripDetailClean()
        showSystemNotification(riname + " has been updated in the trip '"  + rname+  "'");  
        Page_Blur(true)
        var id= getCruiseSailId()
        var dt= getCruiseSailDate()
        if (id==dt){refreshWithQueryParam("dt",id) ;}else{refreshWithQueryParam("id",id) ;}

        

    }
}

function  tripQuickSend_callback(rid, riid,  options,  rname, riname,err,msg) {
    if (err){ 
        showSupportNotification("Unable to create quick report for " + riname + "'");   
    }else{
        doSendTrip(rid,"Send","Quick Send '" +  riname +"'");     
    }  
    }

function  tripQuickPrint_callback(rid, riid,  options,  rname, riname,err,msg) {
    if (err){ 
        showSupportNotification("Unable to create quick report for " + riname + "'");   
    }else{
        printTrip(rid);
    }  
    }
      
function tripPlaceAdded_callback(rid, riid,  options,  rname, riname,err,msg) {
    if (err){ 
        showSupportNotification("Unable to add " + riname + " to the trip '" + rname+  "'");   
    }else{
        setTripDetailClean();
        showSystemNotification(riname + " has been added to the trip '"  + rname+  "'");  
        $(".btn-trip-place-add,.btn-trip-place-add-drop").hide();
        $(".btn-trip-place-remove").show();             
    }
}

function tripQuickAddRemoved_callback(rid, riid,  rname, riname,err) {
    if (err){ 
        showSupportNotification("Unable to remove " + riname + " from the trip '" + rname+  "'");   
    }else{           
        showSystemNotification(riname + " has been removed from the trip '"  + rname+  "'"); 
        searchreportitems=searchreportitems.replace('|'+riid+'|','|');        
        updateSearchChecks()
    }
}                                           

function tripQuickAddItem_callback(rid, riid,  ritype,  rname, riname,err) {
    if (err){ 
        showSupportNotification("Unable to add " + riname + " to the trip '" + rname+  "'");   
      
    }else{
        searchreportitems+=riid+'|';
        updateSearchChecks()
        showSystemNotification(riname + " has been quickly added to the trip '"  + rname+  "'"); 

    }
}

function collectItems() {
    var sItems="";
    $(".chk-content-section:checked" ).each(function( index ) {  
        if ($(this).data("subtype")!="POI"){
            var val=$(this).val();
            if (val!=""){sItems += val + "|";}  
        }
    });

    return sItems
}

function collectPOIItems() {
    var sItems="";
    $(".chk-content-section:checked" ).each(function( index ) {   
        if ($(this).data("subtype")=="POI"){
            var val=$(this).val();
            if (val!=""){sItems += val + "|";}  
        }             
    });

    return sItems
}

function setTripFromSelect(rid, rname,id, typ,n, mode, sid, sdt) {
    Page_Blur(true); 
              
    if (mode==2){
    showSystemNotification("Switching trip to '" + rname + "'.  Refreshing your page"); 
    refreshPageForTrip(rid,rname) ;
    }  else if (mode==1) {
    UpdateReportItem(rid, getTripPlaceId(),  collectItems(),collectPOIItems(),rname, getTripPlaceName(),getTripPlaceType(),tripSelectedPlaceAdded_callback,null) ;
    }else{             
    QuickAddReportItem(rid, id, typ, rname, n, tripSelectedPlaceAdded_callback, sid, sdt);
      
    }
}

function refreshPageForTrip(rid,rname) {
     Page_Blur(true);           
    var req = new Object;    
    req.ReportID = rid;     
    var DTO = { 'Req': req }

    DynaProxy.invoke("SetWorkingTrip",DTO, function (data) {
        setTripDetailClean();  //avoid message
        window.location.href= window.location.href;
    }, function (data) {            
        showSupportNotification("Unable to refresh trip '" +rname + "'");
    })
         
}

document.addEventListener('DOMContentLoaded', () => {    
      window.addEventListener('beforeunload', (event) => {
        if (bTripContentsDirty || bEditDirty) {
            event.preventDefault();                                                                                                                                      
           // event.returnValue = "You have made selections, but have not added this place to a trip, printed, or sent it. Are you sure you want to leave this page?";          //doesnt work on most browsers
        }
      });
    });